import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, post } from "../../../config";
import { toast } from "react-toastify";
import wFavicon from "../../../assets/images/myna-white-favicon.png";
import logo from "../../../assets/images/BuildTrust-white.png";
import abstractImage from "../../../assets/newimages/abstract_image.jpeg";
import Spin from "../../common/Spin";
import { Formik } from "formik";
import SlideToggle from "react-slide-toggle";

const AcceptSubcontractor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const email = query.get("email");
  const contactId = query.get("contact_id");
  const [loading, setLoading] = useState(true);
  const [onLoad, setOnLoad] = useState(false);
  const [role, setRole] = useState();
  const [successMessage, setSuccessMessage] = useState(null);

  const handleFormSubmit = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await post(API.CONTRACTOR_ACCEPT, {
        email: email,
        contact_id: contactId,
      });
      if (data.status === 200) {
        setLoading(false);
        setRole(data?.data?.role?.slug);
        toast.success(data?.message);
        setSuccessMessage(data?.message);
      } else {
        toast.error(data.errors?.bt_error[0]);
      }
    } catch (e) {
      setLoading(false);
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  }, [contactId, email]);

  useEffect(() => {
    onLoad && handleFormSubmit();
  }, [handleFormSubmit, onLoad]);

  useEffect(() => {
    if (successMessage !== null) {
      window.setTimeout(function () {
        navigate("/");
      }, 4000);
    }
  }, [navigate, successMessage, role]);

  return (
    <>
      <div className="login-screen">
        <div className="welcome-block">
          <div className="sitelogo">
            <img
              src={logo}
              alt="BuildTrust"
              style={{ maxWidth: "500px", filter: "brightness(100)" }}
            />
            {/* <span>Beta</span> */}
          </div>
          <div
            className="footer-link"
            style={{ maxWidth: "100%", color: "#CCC", padding: "0 30px" }}
          >
            <p style={{ fontSize: "12px" }}>
              <img className="small-white-favicon" src={wFavicon} alt="" />{" "}
              BuildTrust acknowledges the Traditional Custodians of country
              throughout Australia and their connections to land, sea and
              community. We pay our respect to their Elders past and present and
              extend that respect to all Aboriginal and Torres Strait Islander
              peoples today.
            </p>
            <div className="abstract-image-body">
              <img src={abstractImage} alt="test" />
            </div>
          </div>
        </div>
        <div className="form-block">
          {loading ? "Please wait we are verifying your email address." : ""}
          {loading && <Spin />}
          <Formik>
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit} noValidate>
                {loading ? (
                  ""
                ) : (
                  <>
                    <div className="congrats-block">
                      <h3>Successfully Accepted</h3>
                      <p>Thank you for accepting.</p>
                      <p>
                        Please wait, you will be redirected to the login page.
                      </p>
                    </div>
                  </>
                )}

                {loading && <Spin />}
                {setOnLoad(true)}
              </form>
            )}
          </Formik>
          <div className="footer-link">
            <p>
              Trouble Logging In?{" "}
              <a
                href="https://buildtrust.com.au/contact-us/"
                rel="noreferrer"
                target="_blank"
              >
                Contact Us
              </a>
            </p>
            <p>
              By selecting Login, you agree to our{" "}
              <a href="/terms-of-use" rel="noreferrer" target="_blank1">
                Terms of Use
              </a>{" "}
              and have read and acknowledge our{" "}
              <a
                href="https://buildtrust.com.au/privacy-policy/"
                rel="noreferrer"
                target="_blank2"
              >
                Privacy Policy
              </a>
            </p>
          </div>
          <SlideToggle>
            {({ toggle, setCollapsibleElement }) => (
              <div className="my-collapsible">
                <i
                  className="fa fa-info my-collapsible__toggle"
                  onClick={toggle}
                ></i>
                <div
                  className="my-collapsible__content"
                  ref={setCollapsibleElement}
                >
                  <div className="my-collapsible__content-inner">
                    <p style={{ fontSize: "12px" }}>
                      <img
                        className="small-white-favicon"
                        src={wFavicon}
                        alt=""
                      />{" "}
                      BuildTrust acknowledges the Traditional Custodians of
                      country throughout Australia and their connections to
                      land, sea and community. We pay our respect to their
                      Elders past and present and extend that respect to all
                      Aboriginal and Torres Strait Islander peoples today.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </SlideToggle>
        </div>
      </div>
    </>
  );
};
export default AcceptSubcontractor;
